module.exports = __webpack_public_path__ + "img/avant3.9d4e8c0c.png";